import React from "react";
import { RemoteStorageService } from "common/api/remoteStorage.service";

export interface ScreenShareContextProps {
  remoteStorage: RemoteStorageService;
}

const defaultRemoteStorage: ScreenShareContextProps = {
  remoteStorage: new RemoteStorageService({ callbacks: [], dispatch: () => {} }),
};

export const RemoteStorageContext = React.createContext(defaultRemoteStorage);
